import { useEffect, useState } from 'react';

const useFoxPresence = () => {
  const [hasFoXHeadline, setHasFoXHeadline] = useState(false);
  const [hasFoXBreadcrumbs, setHasFoXBreadcrumbs] = useState(false);

  useEffect(() => {
    const checkFoXHeadlinePresence = () => {
      const breadcrumb = document.getElementsByClassName('breadcrumb')[0];
      if (!breadcrumb) return;

      const breadcrumbItems = breadcrumb.querySelectorAll('.breadcrumb-item');
      const breadcrumbsMinLength = breadcrumbItems.length > 1;

      setHasFoXBreadcrumbs(breadcrumbsMinLength);

      const header = breadcrumb.nextElementSibling;

      const hasCMSHeadline = header?.classList.contains('container-fluid');
      if (hasCMSHeadline) {
        setHasFoXHeadline(true);
      } else {
        setHasFoXHeadline(false);
      }
    };

    checkFoXHeadlinePresence();
  }, []);

  return {
    hasFoXHeadline,
    hasFoXBreadcrumbs,
  };
};

export default useFoxPresence;
